// extracted by mini-css-extract-plugin
export default {"privacy":"Farm_privacy__+hBrG","listLink":"Farm_listLink__vErHF"};